export default function windowConfirm (message) {
    const scrollYPos = window.scrollY
    const answer = window.confirm(message)

    setTimeout(() => {
        // Aborting confirm window caused scroll to top so this function restores position
        window.scroll(0, scrollYPos)
    }, 0)

    return answer
}



// WEBPACK FOOTER //
// ./src/helpers/window-confirm.js